module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d3081fcfb0e88e0c6806aad45d405d2.png";